<template>

	<Drawer initialWidth="4xl" @requestUnmount="hide" :title="title">

		<div class="pl-4 min-h-0 h-full overflow-hidden flex flex-col">
			<GoalEvaluation
				:dateRange="dateRange"
				:withSchedulingSegmentsOptions="true"
				:withGoalCollectionOptions="false"
				:allScheduledGoalsLabel="$t('All goals scheduled in this period')"
			>
			</GoalEvaluation>
		</div>

	</Drawer>

</template>

<script lang="ts">

import { Interval } from "luxon";
import Drawer from "@/components/ui/Drawer.v2.vue";
import GoalEvaluation from "@/components/GoalEvaluation.vue";

export default {
	components: {
		GoalEvaluation,
		Drawer,
	},

	props: {
		title: {
			type: String,
			default: '',
		},
		dateRange: {
			type: Interval,
			required: true,
		}
	},

	emits: [
		'requestUnmount',
	],

	data() {
		return {};
	},

	methods: {
		hide() {
			this.$emit('requestClose');
		}
	},
}

</script>
